import http from '../../../plugins/axios';

export default {

    selectShiZhiTransferInfo(data){
        return http.post({
            url: '/admin/transfer/shizhi/query',
            data,
            dataType:'form'
        })
    },

    exportShiZhiTransferInfo(data){
        return http.post({
            url: '/admin/transfer/shizhi/export',
            data,
            dataType:'form',
            responseType: 'blob'
        })
    }
}
